export default "__VITE_ASSET__BnAyZA0g__"